import { useLazyQuery, useMutation } from '@apollo/client'
import { GET_TPV_CONTRACT_FILES, RETRIEVE_MISSING_CONTRACTS } from '../../../../../utils/GraphQLAPI'
import { Col, Row, Spinner } from 'react-bootstrap'
import PdfViewer from '../../../../sharedComponent/viewer/PDFViewer'
import { renderFileHeader } from '../../../../../utils/Contract/ContractUtils'
import { GLOBAL_CONSTANTS } from '../../../../../utils/GlobalConstants'
import { useEffect } from 'react'
import { isValidURL } from '../../../../../utils/helper'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

const MySwal = withReactContent(Swal)

const ContractTPVReports = ({ tpvId, enrollmentPosition }: { tpvId: string, enrollmentPosition: number }) => {
  const [getTPVContractFiles, { loading, data, error }] = useLazyQuery(GET_TPV_CONTRACT_FILES, {
    variables: {
      tpvId: tpvId,
      enrollmentPosition: enrollmentPosition
    },
    fetchPolicy: GLOBAL_CONSTANTS.networkOnly,
  })

  const [handleLoadContractRetry, { loading: isloading }] = useMutation(RETRIEVE_MISSING_CONTRACTS, {

    onCompleted: () => {
      getTPVContractFiles()
      const options: any = {
        customClass: {
          popup: 'swal2-border-radius',
        },
        title: 'Contract updated successfully',
        icon: 'success',
        confirmButtonColor: '#3E97FF',
      }
      MySwal.fire(options)
    },
    onError: (e) => {
      const options: any = {
        customClass: {
          popup: 'swal2-border-radius',
        },
        title: 'Failed to Update Contract',
        text: e.message || 'An unexpected error occurred. Please try after sometime.',
        icon: 'error',
        confirmButtonColor: '#3E97FF',
      }
      MySwal.fire(options)
    }
  })

  useEffect(() => {
    getTPVContractFiles()
  }, [])
  if (loading) {
    return (
      <div className='text-center'>
        <Spinner animation='border' className='text-gray-600' role='status'>
          <span className='visually-hidden'>Loading...</span>
        </Spinner>
      </div>
    )
  }
  if (error) {
    return (
      <div className='text-center alert alert-danger mt-5'>
        <h4 className='fs7'> {error?.message}</h4>
      </div>
    )
  }

  const FILE_ORDER: Record<number, number> = {
    6: 1, // Welcome Letter
    3: 2, // Contract
    0: 3, // Terms & Conditions
    2: 4, // Other (default lower priority)
  }

  const originalFiles = data?.getTpvContractFilesByTpvId?.productFiles ?? []

  const updatedFiles = [...originalFiles]

  if (data?.getTpvContractFilesByTpvId?.shouldGenerateContract) {
    updatedFiles.push({
      id: 'generated-position-3',
      position: 3,
      fileUrl: '',
      __typename: "TpvContracts"
    })
  }

  const sortedFiles = [...updatedFiles].sort(
    (a: { position: number; id: string }, b: { position: number; id: string }) => {
      if (a?.position === 3 && b?.position === 3) {
        return -1
      }
      return (FILE_ORDER[a.position] ?? 99) - (FILE_ORDER[b.position] ?? 99)
    }
  )

  const handleDownload = (fileUrl: string) => {
    if (!fileUrl || !isValidURL(fileUrl)) {
      MySwal.fire({
        title: 'Invalid File URL',
        icon: 'error',
        confirmButtonColor: '#3E97FF',
      })
      return
    }

    const link = document.createElement('a')
    link.href = fileUrl
    const fileName = fileUrl.split('/').pop() || 'download.pdf'
    link.download = fileName
    link.target = '_blank'
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }

  const handleLoadContract = async () => {
    await handleLoadContractRetry({
      variables: {
        tpvId
      },
    })
  }

  return (
    <div className='tab d-flex flex-row justify-content-between'>
      <Row className='w-100'>
        {data?.getTpvContractFilesByTpvId?.productFiles?.length ? (
          sortedFiles?.map((url: { fileUrl: string; position: number; id: string, isContainsContract: boolean }, i: number) => (
            <Col lg={6} key={url?.fileUrl} className='mb-3'>
              {data?.getTpvContractFilesByTpvId?.shouldGenerateContract && url?.fileUrl === '' ? (
                < >
                  <div className='d-flex align-items-center justify-content-between my-3'>
                    <p className='fs-4 fw-bold mb-0'>{renderFileHeader(url?.position)}</p>
                    <button
                      className="btn btn-primary btn-sm d-flex align-items-center"
                      onClick={handleDownload.bind(null, `${process.env.REACT_APP_IMAGE_BASE_URL}${url?.fileUrl}`)}
                    >
                      Download
                    </button>

                  </div>
                  <div className='example-container'>
                    <button className='retry-button' onClick={handleLoadContract} disabled={isloading}>
                      {isloading && <span className='spinner-border spinner-border-sm align-middle ms-2'></span>}

                      {isloading ? '...loading' : 'Re-retry'}
                    </button>
                  </div>
                </>
              ) : (
                <>
                  <div className='d-flex align-items-center justify-content-between my-3'>
                    <p className='fs-4 fw-bold mb-0'>{renderFileHeader(url?.position)}</p>
                    <button
                      className="btn btn-primary btn-sm d-flex align-items-center"
                      onClick={handleDownload.bind(null, `${process.env.REACT_APP_IMAGE_BASE_URL}${url?.fileUrl}`)}
                    >
                      Download
                    </button>

                  </div>
                  <PdfViewer
                    url={url?.fileUrl}
                    previewSettings={GLOBAL_CONSTANTS.previewSettings}
                    type={'contract'}
                  />
                </>
              )}
            </Col>
          ))
        ) : (
          <div className='text-center'>No files found</div>
        )}
      </Row>
    </div>
  )
}
export default ContractTPVReports
